import { Action } from 'redux';

import { RetryableAction } from 'reducers';
import { ImmutableQuery } from 'services';
import { PaginationStateKeys } from 'types';

/* Types */

export interface PaginationAction extends Action, RetryableAction {
  readonly nextState: PaginationState;
  readonly key: PaginationStateKeys;
}

export interface PaginationState {
  readonly itemsPerPage?: number;
  readonly page?: number;
  readonly query?: ImmutableQuery;
  readonly totalItems?: number;
}

export interface Pagination {
  readonly devices: PaginationState;
  readonly selectedDevices: PaginationState;
  readonly tickets: PaginationState;
}

/* Initial State */

const initialPagination = {
  page: 1,
  totalItems: 0,
  itemsPerPage: 0,
  query: new ImmutableQuery(),
};

const initialState = {
  devices: initialPagination,
  selectedDevices: initialPagination,
  tickets: initialPagination,
};

/* Actions */

enum Actions {
  SET_PAGINATION = 'SET_PAGINATION',
}

const setPagination = (
  key: PaginationStateKeys,
  nextState: PaginationState,
): PaginationAction => ({
  type: Actions.SET_PAGINATION,
  key,
  nextState,
});

/* Reducers */

const paginationReducer = (state = initialState, action: PaginationAction) => {
  switch (action.type) {
    case Actions.SET_PAGINATION:
      // Set defaults to return current state if updating a partial object
      const {
        itemsPerPage = state[action.key].itemsPerPage,
        page = state[action.key].page,
      } = action.nextState;

      const query = state[action.key].query.set({
        offset: String(itemsPerPage * (page - 1)),
        limit: String(itemsPerPage),
      });

      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          ...action.nextState,
          query,
        },
      };

    default:
      return state;
  }
};

export { paginationReducer, setPagination };
